export const getApiUrl = (endpoint) => {
  const path = window.location.pathname;
  const match = path.match(/^\/products\/([^/]+)/);
  let apiPath = endpoint;

  if (match) {
    // Strip '/api' from the start if it exists
    const cleanEndpoint = endpoint.startsWith('/api') ? endpoint.slice(4) : endpoint;
    const slash = cleanEndpoint.startsWith('/') ? '' : '/';
    apiPath = `/api/products/${match[1]}${slash}${cleanEndpoint}`;
  }

  const apiBaseUrl = process.env.REACT_APP_API_URL?.trim().replace(/\/+$/, '');
  if (apiBaseUrl && process.env.NODE_ENV === 'production') {
    const hostname = new URL(apiBaseUrl).hostname.toLowerCase();
    const isLoopbackHost = hostname === 'localhost' ||
      hostname.endsWith('.localhost') ||
      hostname === '[::1]' ||
      /^127(?:\.\d{1,3}){3}$/.test(hostname);
    if (isLoopbackHost) return apiPath;
  }

  return apiBaseUrl ? `${apiBaseUrl}${apiPath}` : apiPath;
};
